import React, { useState } from 'react'
import { GameCssStyles } from '../GameCssStyles'
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import { CATEGORY, CATEGORY_RULES } from '../GameConstant';
import { Add, Remove, CloseRounded, UpdateRounded } from '@mui/icons-material';
import _ from "lodash";
import EntertainmentEntityDialog from './EntertainmentEntityDialog';
import EntertainmentEntityDialogV2 from './EntertainmentEntityDialogV2';
import { generatePublicUrlForFileInAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket';
import { View } from '@aws-amplify/ui-react';
import ViewStatsDialog from './ViewStatsDialog';

const FantasyManiaPool = ({ formGameData, setFormGameData, handleChange }) => {

    const [isOpenEntertainmentEntityDialog, setIsOpenEntertainmentEntityDialog] = useState(false);
    const [isViewStatsDialogOpen, setIsViewStatsDialogOpen] = useState(false);
    const [entityForViewStats, setEntityForViewStats] = useState(null);
    const { mediaEntity = [], entityMedia = [], entityDetails = [], entities = [] } = formGameData || {};
    const groupedEntities = _.groupBy(entityMedia, (item) => {
        //console.log("Grouping by type:", item?.entity?.type);
        return item?.entity?.type;
    });
    const Category = CATEGORY;
    const Category_Rules = CATEGORY_RULES;

    //console.log("FantasyManiaPool formGameData : ", formGameData)
    //console.log("FantasyManiaPool entities : ", entities)
    //console.log("FantasyManiaPool mediaEntity : ", mediaEntity)
    //console.log("FantasyManiaPool entityDetails : ", entityDetails?.length)
    //console.log("FantasyManiaPool entityMedia : ", entityMedia)
    //console.log("FantasyManiaPool groupedEntities : ", groupedEntities)

    return (
        <>
            <Box sx={GameCssStyles.containerStyleColumn_sx}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 0,
                    }}
                >
                    {/* Left: Title */}
                    <Typography variant="h6" fontWeight={600}>
                        Fantasy League Game Pool
                    </Typography>

                    {/* Right: Buttons */}
                    <Box sx={{ display: "flex", gap: 2 }}>
                        {/* <Button variant="contained" size="small" onClick={() => {
                            console.log("View Stats clicked");
                            setIsViewStatsDialogOpen(true)
                        }}>
                            View Stats
                        </Button> */}
                        {/* <Button variant="contained" size="small" onClick={() => {
                            console.log("Submit Stats clicked");
                        }}>
                            Submit Stats
                        </Button> */}
                    </Box>
                </Box>

                {/* <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Fantasy League Game Pool</Typography> */}

                {Object.keys(groupedEntities).map((typeKey) => (
                    <Box key={typeKey}>
                        <Typography variant="subtitle1" fontWeight={600} mb={1} sx={{ alignSelf: "flex-start", textAlign: "left" }}>
                            {typeKey.charAt(0).toUpperCase() + typeKey.slice(1)}s
                        </Typography>

                        <Grid container spacing={2}>
                            {groupedEntities[typeKey].map((option, idx) => (
                                <Grid item key={option?._id || idx}>
                                    <Box
                                        sx={{
                                            position: "relative",
                                            height: 140,
                                            width: 240,
                                            borderRadius: 2,
                                            overflow: "hidden",
                                            backgroundColor: "whitesmoke",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            p: 1,
                                            border: "1px solid #ccc",
                                        }}
                                    >
                                        {/* Thumbnail */}
                                        <Box
                                            sx={{
                                                width: 80,
                                                height: 80,
                                                borderRadius: 2,
                                                overflow: "hidden",
                                                backgroundImage: `url(${generatePublicUrlForFileInAWSS3Bucket(option?.media?.url) || ""})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                mr: 2,
                                                flexShrink: 0,
                                            }}
                                        />

                                        {/* Info area */}
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Typography fontWeight="bold" sx={{ fontSize: 12 }}>
                                                {option?.entity?.displayName}
                                            </Typography>
                                            {/* <Typography variant="body2" noWrap>
                                                {option?.entity?.tags?.map((t) => t?.details?.genreName).join(", ") ||
                                                    option?.entity?.genres?.join(", ") ||
                                                    "N/A"}
                                            </Typography> */}
                                            <Typography variant="caption" color="text.secondary">
                                                {option?.entity?.type}
                                            </Typography>
                                        </Box>

                                        {/* Close button */}
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: 4,
                                                right: 4,
                                            }}
                                        >
                                            <IconButton
                                                onClick={() => {
                                                    setIsViewStatsDialogOpen(true);
                                                    setEntityForViewStats(option)
                                                }}
                                                size="small"
                                                sx={{ p: 0.5 }}
                                            >
                                                <UpdateRounded fontSize="small" />
                                            </IconButton>

                                            <IconButton
                                                onClick={() => {
                                                    //console.log("Remove Entity clicked:", option);
                                                    const updatedEntityMedia = entityMedia?.filter(
                                                        (item) => item?.entity?._id !== option?.entity?._id
                                                    );
                                                    handleChange(`entityMedia`, updatedEntityMedia);

                                                    const updatedEntityDetails = entityDetails?.filter(
                                                        (item) => item?._id !== option?.entity?._id
                                                    );
                                                    handleChange(`entityDetails`, updatedEntityDetails);

                                                    const updatedEntities = entities?.filter(
                                                        (item) => item !== option?.entity?._id
                                                    );
                                                    handleChange(`entities`, updatedEntities);

                                                    const updatedMediaEntity = mediaEntity?.filter(
                                                        (item) => item?.entityId !== option?.entity?._id
                                                    );
                                                    handleChange(`mediaEntity`, updatedMediaEntity);
                                                }}
                                                size="small"
                                                sx={{ p: 0.5 }}
                                            >
                                                <CloseRounded fontSize="small" />
                                            </IconButton>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))}

                <Box mt={2} sx={{ alignSelf: "flex-end" }}>
                    <Button startIcon={<Add />} variant="contained" onClick={() => {
                        setIsOpenEntertainmentEntityDialog(true);
                    }}>
                        Add Entity
                    </Button>
                </Box>
            </Box>

            <EntertainmentEntityDialogV2
                open={isOpenEntertainmentEntityDialog}
                onClose={() => {
                    setIsOpenEntertainmentEntityDialog(false)
                }}
                onSubmit={(selectedIds) => {
                    console.log("selectedItems : ", selectedIds);

                    //setFormGameData((prev) => ({...prev,entityMedia:selectedIds}));
                    // const updatedData = selectedItems?.map(item => ({
                    //     ...item,
                    //     multimedia: item?.multimedia?.length > 0 ? [item?.multimedia[0]] : []
                    // }));

                    handleChange(`entityMedia`, selectedIds);
                }}
                selectedItems={entityMedia || []}
                handleChange={handleChange}
                formGameData={formGameData}
                fullScreen
            />

            <ViewStatsDialog
                open={isViewStatsDialogOpen}
                onClose={() => {
                    setIsViewStatsDialogOpen(false)
                }}
                entityForViewStats={entityForViewStats}
            />
        </>
    )
}

export default FantasyManiaPool
